import DocumentVenteEntity from "./DocumentVenteEntity";

const Facture = () => {
    return <DocumentVenteEntity type="Facture" title="Factures" endpoint="Facture" />;
};

export default Facture;
